import { Box, Container, Heading, Image, Stack } from "@chakra-ui/react";
import useSite from "../../../hooks/use-site";
import { wpStyles } from "../../../theme/wp-styles";
import GravityForms from "../../GravityForms";
import blogMaskBackImg from "../../../assets/img-blog-mask-back.svg";

const Newsletter = () => {
  const {
    newsletterSignup,
    themeGeneralSettings: {
      siteSettings: { footerFormDescription, footerFormTitle },
    },
  } = useSite();
  return (
    <Box
      py={{ base: 4, md: 20 }}
      bg="green.400"
      borderBottomWidth="10px"
      borderBottomColor="green.800"
      borderBottomStyle="solid"
      position="relative"
      overflow="hidden"
    >
      <Container position="relative" zIndex="4">
        <Stack
          direction={{ base: "column", md: "row" }}
          position="relative"
          zIndex="4"
        >
          <Box color="white" flex={{ base: "1", md: ".75" }}>
            <Heading
              color="white"
              fontWeight="bold"
              fontSize={{
                base: "lg !important",
                lg: "xl !important",
              }}
              mb={0}
            >
              {footerFormTitle}
            </Heading>
            <Box
              dangerouslySetInnerHTML={{ __html: footerFormDescription }}
              fontSize={{
                base: "lg",
                lg: "xl",
              }}
              lineHeight="1.0"
              sx={{
                a: {
                  color: "white",
                  textDecoration: "none",
                },
                "a:hover": {
                  color: "white",
                },
              }}
            />
          </Box>
          <Box
            sx={{
              "input, select": {
                fontSize: "16px",
              },
              label: {
                fontWeight: "bold",
              },
            }}
            flex={{ base: "1", md: "1" }}
          >
            {newsletterSignup && <GravityForms form={newsletterSignup} />}
          </Box>
        </Stack>
        <Box
          position="absolute"
          top={{
            base: "-10px",
            lg: "0px",
          }}
          left={{
            base: "-10px",
            lg: "0",
          }}
          maxW={{ base: "80%", lg: "100%" }}
          zIndex="1"
          display={{ base: "none", lg: "block" }}
        >
          <Image
            src={blogMaskBackImg.src}
            width={"600px"}
            height={"600px"}
            className="mask-back"
            alt="Masking Image Back"
            opacity="0.3"
          />
        </Box>
        <Box
          position="absolute"
          top={{
            base: "-10px",
            lg: "-200px",
          }}
          left={{
            base: "-10px",
            lg: "300px",
          }}
          maxW={{ base: "80%", lg: "100%" }}
          zIndex="1"
          display={{ base: "none", lg: "block" }}
        >
          <Image
            src={blogMaskBackImg.src}
            width={"400px"}
            height={"400px"}
            className="mask-back"
            alt="Masking Image Back"
            opacity="0.3"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Newsletter;
